import React, { useEffect, useState } from "react";
import DashboardFilterBar, {
  isAllFilter,
} from "../../components/ui/dashboard/DashboardFilterBar";
import useDebouncedValue from "../../hooks/useDebouncedValue";
import { ExpenseItemSearchRequest } from "./@types";
import ExportExpenseModal from "./components/ExportExpenseModal";
import ExportIncomeModal from "./components/ExportIncomeModal";
import FinanceStats from "./components/FinanceStats";
import ExpenseDashTab from "./refactor/ExpenseDashTab";
import IncomeDashTab from "./refactor/IncomeDashTab";
import FinanceFilterComponent from "./ui/FinanceFilterComponent";

const FinanceDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState("income");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const debouncedKeyword = useDebouncedValue(searchTerm.trim());

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    category: "",
  });

  const requestBody: ExpenseItemSearchRequest = {
    pageNumber: currentPage,
    pageSize,
    keyword: debouncedKeyword || undefined,
    startDate: filterData.startDate || undefined,
    endDate: filterData.endDate || undefined,
    category:
      isAllFilter(filterData.category) || filterData.category === "All"
        ? undefined
        : filterData.category || undefined,
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [debouncedKeyword, filterData.startDate, filterData.endDate, filterData.category]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(0);
  };

  const TabContent = () => {
    if (activeTab === "income") {
      return (
        <IncomeDashTab
          requestBody={requestBody}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      );
    } else if (activeTab === "expense") {
      return (
        <ExpenseDashTab
          requestBody={requestBody}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      );
    }
    return null;
  };

  return (
    <div className="min-h-screen py-6 w-full bg-[#F9F9F9] p-4">
      <div className="w-full mx-auto space-y-6">
        <FinanceStats />
        <div className="bg-white rounded-[10px] p-2 mt-5 h-[70px] flex items-center overflow-x-auto">
          <nav className="flex px-2 whitespace-nowrap min-w-max">
            <button
              onClick={() => setActiveTab("income")}
              className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                activeTab === "income"
                  ? "bg-primary/20 text-primary rounded-[8px]"
                  : "border-transparent text-pColor hover:text-hColor"
              }`}
            >
              Income
            </button>
            <button
              onClick={() => setActiveTab("expense")}
              className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                activeTab === "expense"
                  ? "bg-primary/20 text-primary rounded-[8px]"
                  : "border-transparent text-pColor hover:text-hColor"
              }`}
            >
              Expense
            </button>
          </nav>
        </div>
        {/* Tab Content */}
        <div className="mt-5">
          {/* Search */}
          <div className="flex items-start justify-between gap-3 mb-4 bg-white rounded-[10px] p-4">
            <DashboardFilterBar
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onClearSearch={() => setSearchTerm("")}
              searchPlaceholder="Search income or expenses"
            />
            <div className="flex gap-2 shrink-0">
              <FinanceFilterComponent onApplyFilters={setFilterData} />

              {activeTab === "expense" ? (
                <ExportExpenseModal />
              ) : (
                <ExportIncomeModal />
              )}
            </div>
          </div>
          <TabContent />
        </div>
      </div>
    </div>
  );
};

export default FinanceDashboard;
